export default __webpack_public_path__ + "static/award_2-dc361ad6994106a816d1bb32f437db86.svg";